import React from "react";

interface ITourismChoose {
  svg: string;
  title: string;
  description: string;
}

const TourismChoose: React.FC = () => {
  const tourismChooseData: ITourismChoose[] = [
    {
      svg: "/tourism/choose/seamless-navigation.svg",
      title: "Seamless Navigation",
      description:
        "Explore landmarks effortlessly with GPS and Bluetooth integration.",
    },
    {
      svg: "/tourism/choose/audio-guides.svg",
      title: "Immersive Audio Guides",
      description:
        "Learn fascinating stories and facts with captivating audio narration.",
    },
    {
      svg: "/tourism/choose/multi-lingual-support.svg",
      title: "Multi-Lingual Support",
      description: "Break language barriers and connect with global tourists.",
    },
    {
      svg: "/tourism/choose/customizable-content.svg",
      title: "Customizable Content",
      description:
        "Tailored guides for museums, pilgrim sites, and cultural hubs.",
    },
  ];

  return (
    <div>
      <div className="flex justify-center items-center">
        <h3 className="text-center text-[#050B20] text-3xl sm:text-4xl lg:text-5xl xl:text-6xl">
          Why Choose Us?
        </h3>
      </div>
      <div className="pt-5 lg:pt-7 xl:pt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 xl:gap-10">
        {tourismChooseData.map((data) => {
          return (
            <div className="shadow rounded-lg p-5 lg:px-7" key={data.title}>
              <div className="flex justify-start">
                <img
                  src={data.svg}
                  alt=""
                  className="w-10 h-10 lg:w-12 lg:h-12"
                />
              </div>
              <h5 className="font-medium text-xl lg:text-2xl xl:text-3xl">
                {data.title}
              </h5>
              <p className="pt-2">{data.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TourismChoose;
